<template>
  <div id="app">

    <b-navbar class="m-0 p-0 d-block d-lg-none">
      <b-navbar-brand href="/">
        <img :src="logo_src" class="img-fluid">
      </b-navbar-brand>
      <a role="button" @click="switchLang" class="ml-2"><img :src="lang_src" class="wh_flag" /></a>
    </b-navbar>

    <b-container fluid class="shmu-border px-0 px-md-3">
      <nwp-alaef v-if="!isIE11" />
      <div v-if="isIE11" class="alert alert-danger text-center">
        <h3>Vizualizáciu nie je možné zobraziť</h3>
        Mrzí nás to, ale Váš internetový prehliadač je zastaralý a nedokáže správne zobraziť túto interaktívnu vizualizáciu.<br>
        Odporúčame Vám používať aktuálnu verziu internetového prehliadača
        (
        <a href="https://www.microsoft.com/edge" target="_blank" rel="noopener">Microsoft Edge</a>,
        <a href="https://www.google.com/chrome" target="_blank" rel="noopener">Chrome</a>,
        <a href="https://www.mozilla.org/firefox/" target="_blank" rel="noopener">Firefox</a>,
        <a href="https://www.apple.com/safari/" target="_blank" rel="noopener">Safari</a>
        )
      </div>
    </b-container>
  </div>
</template>


<script>
  import i18n from './i18n'
  import alaef from "../../components/nwp-alaef";
  import SHMUconf from '../../shmu_conf'

  export default {
    components: {
      'nwp-alaef': alaef,
    },
    data: function()  {
      return {}
    },
    computed: {
      isIE11: function() {
        return !!window.MSInputMethodContext && !!document.documentMode;
      },
      logo_src: function() {
        let lang = 'sk';
        if (['sk','en'].includes(i18n.locale)>0) {
          lang = i18n.locale;
        }
        //return this.getImgUrl('shmu-logo-' + lang + '.png')
        return SHMUconf.IMG_ASSETS_PATH + 'shmu-logo-' + lang + '.png';
      },
      lang_src: function() {
        let lang = 'sk';
        if (i18n.locale === 'sk') lang = 'en';
        return SHMUconf.IMG_ASSETS_PATH + 'flag_'+lang+'.svg';
      }

    },
    methods: {
      switchLang() {
        let lang = 'sk';
        if (i18n.locale === 'sk') lang = 'en';
        i18n.locale = lang;
      }
    }
  }
</script>

<style lang="scss">
  .wh_flag {
    width: 35px;
    height: 35px;
  }
</style>
